import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Checkbox from "@mui/material/Checkbox";
import CloseIcon from "@mui/icons-material/Close";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { fAlertToast } from "../../../Utility/Utilitys";
import {
  CmpButton,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky.jsx";
const GCSalesOrderQuotation = ({
  open = false,
  GCSalesOrderQuotationActiveStep,
  setGCSalesOrderQuotationActiveStep,
  xTitle = "",
  fCloseModal = () => {},
  vMediaQuery = false,
  sGCSalesQuotationHeadRow,
  sGCSalesQuotationHeadColumn,
  sGCSalesQuotationDetailRow,
  sGCSalesQuotationDetailColumn,
  xOnRowClickHead,
  xOnRowClickDetail,
  setGridEditing,
  sGridEditing,
  fMore,
  fPendingQuotation_Load,
  setGCSalesQuotationDetailRow,
}) => {
  const fEditQty = (params) => {
    if (params?.value > Number(params?.row?.B_Qty)) {
      // Show an alert or handle the error as needed
      fAlertToast("INFO", "EditQty cannot be greater than Qty");
    }
    // let itemList = sGCSalesQuotationDetailRow.map((i) => {
    //   return i.B_Srno === params.row.B_Srno
    //     ? {
    //         ...i,
    //         EditQty:
    //           Number(params.value) > Number(params.row.B_Qty)
    //             ? Number(params.row.B_Qty)
    //             : Number(params.value),
    //         Selected: Number(params.value) <= 0 ? "N" : "Y",
    //       }
    //     : i;
    // });
    // let itemList = sGCSalesQuotationDetailRow;
    // for (let x of itemList) {
    //   if (x?.id === params.row?.id) {
    //     x.EditQty =
    //       Number(params.value) > Number(params.row.B_Qty)
    //         ? Number(params.row.B_Qty)
    //         : Number(params.value);
    //     x.Selected = Number(params.value) <= 0 ? "N" : "Y";
    //     return x;
    //   } else {
    //     return x;
    //   }
    // }

    const itemList = sGCSalesQuotationDetailRow?.map((x) => {
      if (x?.id === params.row?.id) {
        x.EditQty =
          Number(params.value) > Number(params.row.B_Qty)
            ? Number(params.row.B_Qty)
            : Number(params.value);
        x.Selected = Number(params.value) <= 0 ? "N" : "Y";
        return x;
      } else {
        return x;
      }
    });
    setGCSalesQuotationDetailRow(itemList);
    params.row.EditQty =
      Number(params.value) > Number(params.row.B_Qty)
        ? Number(params.row.B_Qty)
        : Number(params.value);
    params.row.Selected = Number(params.value) <= 0 ? "N" : "Y";
    return params.row;
  };
  const columns = sGCSalesQuotationDetailColumn.map((x) => {
    if (x.field === "EditQty") {
      return {
        ...x,
        valueSetter: fEditQty,
        editable: true,
        type: "number",
      };
    } else {
      return x;
    }
  });
  return (
    <Modal
      open={open}
      onClose={fCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
        <GCTitleSticky title={xTitle} onClose={fCloseModal} />
        
          
          <div className="p-2">
            {GCSalesOrderQuotationActiveStep === 0 ? (
              <Grid container spacing={1} columns={{ xs: 4, sm: 4, md: 12 }}>
                <Grid item xs={12} className="GCSearchBtn-label mt-2">
                  <div
                    style={{
                      height: vMediaQuery ? "45vh" : "68vh",
                      width: "100%",
                    }}
                    id="table-main-grid-4"
                  >
                    <DataGrid
                      rowHeight={30}
                      headerHeight={40}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "mui-even-row"
                          : "mui-odd-row"
                      }
                      sx={{
                        border: 1,
                        borderColor: "primary.light",
                      }}
                      rows={sGCSalesQuotationHeadRow}
                      columns={
                        sGCSalesQuotationHeadColumn.length > 0
                          ? sGCSalesQuotationHeadColumn
                          : [
                              {
                                field: "id",
                                headerName: "ID",
                                width: 70,
                                hide: false,
                              },
                            ]
                      }
                      onCellKeyDown={(newSelectionModel, e) => {
                        if (e.key === "Enter") {
                          xOnRowClickHead(newSelectionModel);
                        }
                      }}
                      onRowClick={xOnRowClickHead}
                      hideFooter={sGCSalesQuotationHeadColumn.length < 100}
                      components={{
                        Toolbar: GridToolbar,
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={1} columns={{ xs: 4, sm: 4, md: 12 }}>
                <Grid item xs={12} className="GCSearchBtn-label mt-2">
                  <div
                    style={{
                      height: vMediaQuery ? "45vh" : "68vh",
                      width: "100%",
                    }}
                    id="table-main-grid-4"
                  >
                    <DataGrid
                      rowHeight={30}
                      headerHeight={40}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "mui-even-row"
                          : "mui-odd-row"
                      }
                      sx={{
                        border: 1,
                        borderColor: "primary.light",
                      }}
                      // getRowId={(row) => row?.B_Srno}
                      rows={sGCSalesQuotationDetailRow}
                      columns={
                        columns.length > 0
                          ? columns
                          : [
                              {
                                field: "id",
                                headerName: "ID",
                                width: 70,
                                hide: false,
                              },
                            ]
                      }
                      onCellKeyDown={(newSelectionModel, e) => {
                        if (e.key === "Enter") {
                          xOnRowClickDetail(newSelectionModel);
                        }
                      }}
                      onRowClick={xOnRowClickDetail}
                      checkboxSelection={true}
                      onSelectionModelChange={(params) => {
                        const item = sGCSalesQuotationDetailRow?.map((x) => {
                          x.Selected = params.includes(x.id) ? "Y" : "N";
                          x.EditQty = params.includes(x.id)
                            ? x.EditQty > 0
                              ? x.EditQty
                              : x.B_Qty
                            : 0;
                          return x;
                        });
                        setGCSalesQuotationDetailRow(item);
                      }}
                      selectionModel={sGCSalesQuotationDetailRow
                        .filter((row) => row?.Selected === "Y")
                        .map((row) => row?.id)}
                      hideFooter={sGCSalesQuotationDetailRow.length < 100}
                      components={{
                        Toolbar: GridToolbar,
                      }}
                      disableSelectionOnClick
                      onCellEditStart={() => setGridEditing(true)}
                      onCellEditStop={() => setGridEditing(false)}
                      onCellEditCommit={() => setGridEditing(false)}
                    />
                  </div>
                  <div className="py-2">
                    <Grid
                      container
                      spacing={1}
                      columns={{ xs: 12, sm: 12, md: 12 }}
                      justifyContent={"center"}
                    >
                      <Grid
                        item
                        xs={4}
                        sm={4}
                        md={1}
                        className="GCSearchBtn-label "
                      >
                        <CmpButton
                          xbtnName="Previous"
                          xOnClick={(e) => {
                            fMore("previous");
                            setGCSalesOrderQuotationActiveStep(0);
                          }}
                          xVariant="contained"
                          xDisabled={GCSalesOrderQuotationActiveStep === 0}
                          xSize="small"
                        />
                      </Grid>
                      {/* <Grid
                        item
                        xs={4}
                        sm={4}
                        md={1}
                        className="GCSearchBtn-label "
                      >
                        <CmpButton
                          xbtnName="Next"
                          xOnClick={(e) => {
                            setGCSalesOrderQuotationActiveStep(1);
                          }}
                          xVariant="contained"
                          xDisabled={GCSalesOrderQuotationActiveStep !== 0}
                          xSize="small"
                        />
                      </Grid> */}
                      <Grid
                        item
                        xs={4}
                        sm={4}
                        md={1}
                        className="GCSearchBtn-label "
                      >
                        <CmpButton
                          xbtnName="Load"
                          xOnClick={(e) => {
                            fPendingQuotation_Load(e);
                          }}
                          xVariant="contained"
                          xDisabled={
                            GCSalesOrderQuotationActiveStep === 0 ||
                            sGridEditing
                          }
                          xSize="small"
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            )}
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default GCSalesOrderQuotation;
